import React from "react";
import Header from "../components/Header";
import HeroSlider from "../components/HeroSlider";
import AboutSection from "../components/AboutSection";
import Timeline from "../components/Timeline"; 
import MapSection from "../components/MapSection";
import ServicesTabs from "../components/ServicesTabs";
import SummarySection from "../components/SummarySection";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";

const HomePage = () => {
  return (
    <>
      <Header />
      <HeroSlider />
      <AboutSection />
      <Timeline />
      <MapSection />
      <ServicesTabs />
      <SummarySection />
      <Footer />
      <BackToTop />
    </>
  );
};

export default HomePage;
